import { Type } from "class-transformer";
import { ExtractedPurchaseOrderHeaderDto } from "./extracted-purchase-order-header.dto";
import { ExtractedPurchaseOrderLineDto } from "./extracted-purchase-order-line.dto";

export class ExtractPurchaseOrderLinesResultDto {
  @Type(() => ExtractedPurchaseOrderHeaderDto)
  header: ExtractedPurchaseOrderHeaderDto;

  @Type(() => ExtractedPurchaseOrderLineDto)
  lines: ExtractedPurchaseOrderLineDto[];

  rawText: string;
}
